var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#7165fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5598 17.2875V23.8839H21.7354V17.7295C21.7354 16.1842 21.1832 15.129 19.7985 15.129C18.7418 15.129 18.114 15.8394 17.8368 16.5274C17.7361 16.7732 17.7102 17.1146 17.7102 17.4594V23.8836H13.8854C13.8854 23.8836 13.9368 13.4602 13.8854 12.3812H17.7104V14.0112C17.7027 14.024 17.6919 14.0366 17.6851 14.0488H17.7104V14.0112C18.2187 13.2291 19.1251 12.1111 21.1573 12.1111C23.6734 12.1111 25.5598 13.7551 25.5598 17.2875ZM9.88442 6.83661C8.57613 6.83661 7.7202 7.69539 7.7202 8.8237C7.7202 9.92805 8.55132 10.8117 9.83422 10.8117H9.85903C11.193 10.8117 12.0224 9.92805 12.0224 8.8237C11.997 7.69539 11.193 6.83661 9.88442 6.83661ZM7.94752 23.8839H11.7708V12.3812H7.94752V23.8839Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLnIcon);
export default __webpack_public_path__ + "static/media/newLNIcon.16d910c0308561380e3d1a55d28fbb23.svg";
export { ForwardRef as ReactComponent };